var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("div", [
    _c(
      "label",
      {
        staticClass: "studiprequired",
      },
      [
        _vm._v("\n        " + _vm._s(_vm.$gettext("Titel"))),
        _c(
          "span",
          {
            staticClass: "asterisk",
            attrs: {
              title: _vm.$gettext("Dies ist ein Pflichtfeld"),
              "aria-hidden": "true",
            },
          },
          [_vm._v("*")]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.title,
              expression: "title",
            },
          ],
          attrs: {
            type: "text",
            required: "",
          },
          domProps: {
            value: _vm.title,
          },
          on: {
            input: function input($event) {
              if ($event.target.composing) return
              _vm.title = $event.target.value
            },
          },
        }),
      ]
    ),
    _vm._v(" "),
    _c(
      "label",
      {
        staticClass: "studiprequired",
      },
      [
        _vm._v("\n        " + _vm._s(_vm.$gettext("Beschreibung"))),
        _c(
          "span",
          {
            staticClass: "asterisk",
            attrs: {
              title: _vm.$gettext("Dies ist ein Pflichtfeld"),
              "aria-hidden": "true",
            },
          },
          [_vm._v("*")]
        ),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.description,
              expression: "description",
            },
          ],
          attrs: {
            required: "",
          },
          domProps: {
            value: _vm.description,
          },
          on: {
            input: function input($event) {
              if ($event.target.composing) return
              _vm.description = $event.target.value
            },
          },
        }),
      ]
    ),
    _vm._v(" "),
    _c(
      "label",
      {
        staticClass: "studiprequired",
      },
      [
        _vm._v("\n        " + _vm._s(_vm.$gettext("Erstellt durch"))),
        _c(
          "span",
          {
            staticClass: "asterisk",
            attrs: {
              title: _vm.$gettext("Dies ist ein Pflichtfeld"),
              "aria-hidden": "true",
            },
          },
          [_vm._v("*")]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.author,
              expression: "author",
            },
          ],
          attrs: {
            type: "text",
            required: "",
          },
          domProps: {
            value: _vm.author,
          },
          on: {
            input: function input($event) {
              if ($event.target.composing) return
              _vm.author = $event.target.value
            },
          },
        }),
      ]
    ),
    _vm._v(" "),
    _c(
      "label",
      {
        staticClass: "studiprequired",
      },
      [
        _vm._v("\n        " + _vm._s(_vm.$gettext("Lizenz"))),
        _c(
          "span",
          {
            staticClass: "asterisk",
            attrs: {
              title: _vm.$gettext("Dies ist ein Pflichtfeld"),
              "aria-hidden": "true",
            },
          },
          [_vm._v("*")]
        ),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.license,
              expression: "license",
            },
          ],
          attrs: {
            required: "",
          },
          domProps: {
            value: _vm.license,
          },
          on: {
            input: function input($event) {
              if ($event.target.composing) return
              _vm.license = $event.target.value
            },
          },
        }),
      ]
    ),
    _vm._v(" "),
    _c(
      "label",
      [
        _vm._v("\n        " + _vm._s(_vm.$gettext("Tags")) + "\n        "),
        _c("TagsInput", {
          attrs: {
            suggestions: _vm.suggestedTags,
          },
          model: {
            value: _vm.tags,
            callback: function callback($$v) {
              _vm.tags = $$v
            },
            expression: "tags",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }